export default __webpack_public_path__ + "static/media/art-3-main-sm.3d3dc371.jpg";